<template>
  <div id="player-controls" class="is-overlay poly-shadow">
    <div class="columns is-vcentered is-gapless is-paddingless is-marginless">
      <div v-if="currentTrack" id="player-info" class="column is-4">
        <div class="columns is-mobile is-vcentered is-variable is-2">
          <div class="column is-narrow">
            <router-link to="/queue">
              <album-cover
                v-bind:album="this.currentTrack.album"
                v-bind:isSmall="true"
                class="is-48x48"
              />
            </router-link>
          </div>

          <div id="player-info-track" class="column poly-truncate">
            <dl v-if="currentTrack">
              <dd id="track-name" class="is-size-7 has-text-weight-bold poly-truncate">
                {{ currentTrack.name }}
              </dd>
              <dd class="is-size-7 track-artist has-text-grey-light has-text-weight-semibold poly-truncate">
                {{ currentTrackArtistNames }} - {{ currentTrack.album.name }}
              </dd>
            </dl>
          </div>

          <div id="player-liked-track" class="column is-narrow is-centered">
            <like-track v-bind:track="this.currentTrack" />
          </div>
        </div>
      </div>

      <div id="player-navbar" class="column">
        <div class="columns is-mobile is-vcentered is-variable is-2">
          <div class="column has-text-centered">
            <router-link to="/">
              <span class="icon has-text-grey-darker poly-cursor-pointer">
                <i class="mdi mdi-18px mdi-home-variant"></i>
              </span>
            </router-link>
          </div>

          <div class="column has-text-centered">
            <span v-on:click="previousTrack" class="icon has-text-grey-darker poly-cursor-pointer">
              <i class="mdi mdi-18px mdi-skip-backward"></i>
            </span>
          </div>

          <div class="column has-text-centered">
            <span v-on:click="togglePlay" class="icon has-text-grey-darker poly-cursor-pointer">
              <i v-if="isPlaying" class="mdi mdi-18px mdi-pause"></i>
              <i v-else class="mdi mdi-18px mdi-play"></i>
            </span>
          </div>

          <div class="column has-text-centered">
            <span v-on:click="nextTrack" class="icon has-text-grey-darker poly-cursor-pointer">
              <i class="mdi mdi-18px mdi-skip-forward"></i>
            </span>
          </div>

          <div class="column has-text-centered">
            <router-link to="/search">
              <span class="icon has-text-grey-darker">
                <i class="mdi mdi-18px mdi-magnify"></i>
              </span>
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import AlbumCover from '@/components/AlbumCover'
  import LikeTrack from '@/components/LikeTrack'

  export default {
    name: 'PlayerControls',
    components: {
      AlbumCover,
      LikeTrack
    },
    computed: {
      currentTrack: function () {
        return this.$store.getters.currentTrack
      },
      currentTrackArtistNames: function () {
        return this.currentTrack.artists.map(
          (artist) => { return artist.name }
        ).join(", ")
      },
      isPlaying: function () {
        return this.$store.getters.isPlaying
      }
    },
    methods: {
      togglePlay: function () {
        this.$store.commit('togglePlay')
      },
      nextTrack: function () {
        this.$store.commit('nextTrack')
      },
      previousTrack: function () {
        this.$store.commit('previousTrack')
      }
    }
  }
</script>

<style scoped lang="scss">
  @import "~bulma/sass/utilities/initial-variables";

  #player-controls {
    position: fixed;
    top: auto;
    z-index: 999;
    background-color: white;
  }

  #player-controls #player-info {
    padding: 0.5rem !important;
    border-right: 1px solid $white-ter;
  }

  #player-controls #player-liked-track {
    margin-right: 1.5rem;
  }

  #player-controls #player-navbar {
    padding: 1.0rem !important;
  }

  #track-name {
    font-size: 0.85rem !important;
  }

  .truncate {
    display: block;
    display: -webkit-box; /* Fallback for non-webkit */
    margin: 0 auto;       /* Fallback for non-webkit */
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
  }

  // Mobile specific modifiers
  @media (max-width: $tablet - 1) {
    #player-controls #player-navbar {
      border-top: 1px solid $white-ter;
      padding: 0.8rem !important;
    }

    #player-controls #player-info {
      border-right: none;
    }

    #player-controls #player-info-track {
      padding-left: 0.1rem !important;
      margin-right: 0.6rem !important;
    }
  }
</style>
